<template>
  <div
    data-qa="doctor_service_prices_price_list"
    class="doctor-service-prices-price-list"
  >
    <div
      v-for="({ name, priceList }, categoryIndex) in categoryList"
      :key="categoryIndex"
      :class="{
        'mb-8': isMobile && categoryIndex < categoryList.length - 1,
        'mb-12': !isMobile && categoryIndex < categoryList.length - 1,
      }"
    >
      <div
        data-qa="doctor_service_prices_category"
        class="text-h6 text--text mb-6"
      >
        {{ name }}
      </div>
      <div
        v-for="(item, index) in priceList"
        :key="index"
        data-qa="doctor_service_prices_price_item"
        class="doctor-service-prices-price-list__item flex-wrap"
        :class="{
          'mb-4': isMobile && index < priceList.length - 1,
          'mb-6': !isMobile && index < priceList.length - 1,
        }"
      >
        <template v-if="isMobile">
          <div class="mb-3">
            <div
              data-qa="doctor_service_prices_price_item_name"
              class="text-body-1 text--text"
            >
              {{ item.name }}
            </div>
            <div
              v-if="item.duration"
              data-qa="doctor_service_prices_price_item_duration"
              class="text-body-2 text-secondary--text"
            >
              {{ getDurationText(item) }}
            </div>
            <div
              v-if="item.agesText"
              data-qa="doctor_service_prices_price_item_ages_text"
              class="text-body-2 text-secondary--text"
            >
              {{ item.agesText }}
            </div>
          </div>
          <div
            class="d-flex justify-space-between align-center"
          >
            <div
              data-qa="doctor_service_prices_price_item_price"
              class="text-subtitle-1 text--text"
            >
              {{ item.formattedPrice }}
            </div>
            <div
              :style="{
                width: '180px',
              }"
              class="d-flex justify-end"
            >
              <v-btn
                v-if="item.hasSlots && item.isEnabledServiceDirect && !item.isEnabledCalendar"
                block
                depressed
                color="primary"
                data-qa="doctor_service_prices_price_item_show_calendar"
                @click="emitShowCalendar({ synonymId: item.synonymId })"
              >
                <span class="ui-icon-calendar-date-and-clock bg-gray-0--text mr-2" />
                <span class="text-subtitle-1 bg-gray-0--text">
                  {{ i18next.t('Запись онлайн', { ns: userLanguage }) }}
                </span>
              </v-btn>
              <v-btn
                v-if="item.isEnabledCalendar"
                depressed
                width="56"
                height="40"
                min-width="56"
                color="bg-gray-40"
                data-qa="doctor_service_prices_price_item_hide_calendar"
                @click="emit('click:hide-calendar')"
              >
                <div class="w-100 h-100 d-flex align-center justify-center">
                  <span class="b-lpu-services__toggle-calendar-icon ui-icon-arrow-up icon-secondary--text" />
                </div>
              </v-btn>
            </div>
          </div>
          <div
            v-show="item.isEnabledCalendar"
            :id="`doctor-price-calendar-wrapper-${item.synonymId}`"
            class="mt-4"
            data-qa="doctor_service_prices_calendar_wrapper"
          />
          <v-divider
            v-if="index < priceList.length - 1"
            class="mt-4"
          />
        </template>
        <template v-else>
          <div class="d-flex">
            <div
              :style="{
                width: 'calc(100% - 400px)',
              }"
            >
              <div
                data-qa="doctor_service_prices_price_item_name"
                class="text-body-1 text--text"
              >
                {{ item.name }}
              </div>
              <div
                v-if="item.duration"
                data-qa="doctor_service_prices_price_item_duration"
                class="text-body-2 text-secondary--text"
              >
                {{ getDurationText(item) }}
              </div>
              <div
                v-if="item.agesText"
                data-qa="doctor_service_prices_price_item_ages_text"
                class="text-body-2 text-secondary--text"
              >
                {{ item.agesText }}
              </div>
            </div>
            <div class="d-flex justify-space-between align-center">
              <div
                data-qa="doctor_service_prices_price_item_price"
                class="text-subtitle-1 text--text text-right d-flex justify-end align-center pr-6"
                :style="{
                  width: '130px',
                }"
              >
                {{ item.formattedPrice }}
              </div>
              <div
                :style="{
                  width: '270px',
                }"
                class="d-flex justify-end"
              >
                <v-btn
                  v-if="item.hasSlots && item.isEnabledServiceDirect && !item.isEnabledCalendar"
                  block
                  depressed
                  color="primary"
                  data-qa="doctor_service_prices_price_item_show_calendar"
                  @click="emitShowCalendar({ synonymId: item.synonymId })"
                >
                  <span class="ui-icon-calendar-date-and-clock bg-gray-0--text mr-2" />
                  <span class="text-subtitle-1 bg-gray-0--text">
                    {{ i18next.t('Запись онлайн', { ns: userLanguage }) }}
                  </span>
                </v-btn>
                <v-btn
                  v-if="item.isEnabledCalendar"
                  depressed
                  width="56"
                  height="40"
                  min-width="56"
                  color="bg-gray-40"
                  data-qa="doctor_service_prices_price_item_hide_calendar"
                  @click="emit('click:hide-calendar')"
                >
                  <div class="w-100 h-100 d-flex align-center justify-center">
                    <span class="b-lpu-services__toggle-calendar-icon ui-icon-arrow-up icon-secondary--text" />
                  </div>
                </v-btn>
              </div>
            </div>
          </div>
          <div
            v-show="item.isEnabledCalendar"
            :id="`doctor-price-calendar-wrapper-${item.synonymId}`"
            class="mt-4"
            data-qa="doctor_service_prices_calendar_wrapper"
          />
        </template>
      </div>
    </div>
    <v-btn
      v-if="isShowMoreButtonVisible"
      color="bg-primary"
      elevation="0"
      class="primary--text mt-4"
      :class="{ 'mx-auto': !isMobile }"
      @click="emit('click:show-more-services')"
    >
      {{ showMoreButtonText }}
    </v-btn>
  </div>
</template>

<script lang="ts" setup>
import i18next from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'
import declensionByNum from 'www/utils/executors/declensionByNum'

defineProps<{
  categoryList: Array<{
    name: string,
    priceList: Array<{
      name: string,
      formattedPrice: string,
      agesText: string,
      categoryName: string
      hasSlots: boolean
      synonymId: number
      isEnabledCalendar: boolean
      isEnabledServiceDirect: boolean
      duration: number
    }>,
  }>,
  showMoreButtonText: string,
  isShowMoreButtonVisible: boolean,
}>()

const emit = defineEmits(['click:show-calendar', 'click:hide-calendar', 'click:show-more-services'])
const isMobile = window.MOBILE_VERSION
const userLanguage = getUserLanguage()

function emitShowCalendar({ synonymId }: { synonymId: number }) {
  const el = document.getElementById(`doctor-price-calendar-wrapper-${synonymId}`)

  emit('click:show-calendar', { synonymId, el })
}

function getDurationText(item: { duration: number }) {
  const durationText = declensionByNum(item.duration, ['минута', 'минуты', 'минут'])

  return `${item.duration} ${i18next.t(durationText, { ns: userLanguage })}`
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';

.doctor-service-prices-price-list {
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>
